import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { OfferFragmentDoc } from '../../fragments/__generated__/Offer.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OfferListQueryVariables = Types.Exact<{
  first: Types.Scalars['Int']['input'];
}>;


export type OfferListQuery = { offerList: { edges: Array<{ node: { id: string, name: string, description: string, sortOrder: number, url: string } }> } };


export const OfferListDocument = gql`
    query OfferList($first: Int!) {
  offerList(first: $first) {
    edges {
      node {
        ...OfferFragment
      }
    }
  }
}
    ${OfferFragmentDoc}`;

/**
 * __useOfferListQuery__
 *
 * To run a query within a React component, call `useOfferListQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferListQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useOfferListQuery(baseOptions: Apollo.QueryHookOptions<OfferListQuery, OfferListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OfferListQuery, OfferListQueryVariables>(OfferListDocument, options);
      }
export function useOfferListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OfferListQuery, OfferListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OfferListQuery, OfferListQueryVariables>(OfferListDocument, options);
        }
export type OfferListQueryHookResult = ReturnType<typeof useOfferListQuery>;
export type OfferListLazyQueryHookResult = ReturnType<typeof useOfferListLazyQuery>;
export type OfferListQueryResult = Apollo.QueryResult<OfferListQuery, OfferListQueryVariables>;
export function refetchOfferListQuery(variables: OfferListQueryVariables) {
      return { query: OfferListDocument, variables: variables }
    }